// extracted by mini-css-extract-plugin
export default {"mainWrapper":"PerType_mainWrapper__FZ28C","title":"PerType_title__rMGzk","placeholder":"PerType_placeholder__oUad5"};